import { MODEL_List, HAND_List, POSTER_List } from '@/enums/common/modules'
import { homePageTemplate } from '@/utils/mysqTools'
const state = {
  // 状态数据
  template_list: [
    // 海报模特 =================================================================================================================================
    {
      id: 0,
      genid: MODEL_List[0],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/womanportrait/175014821510029074.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/womanportrait/175014830090914959.png',
      localstoragename: 'womanportrait',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Woman/【欧美】真实感黑人女模_v2.0.safetensors',
      default: '',
      english: 'Photograph of a stunning Black woman with dark skin and curly hair styled in an elegant updo. She wears a black,off-the-shoulder gown adorned with sequins,and a sparkling diamond necklace. Her makeup is glamorous with bold eyeliner and nude lipstick. The background features a geometric,dark blue and white pattern.,',
      chinese: '照片上是一位迷人的黑人女性,深色皮肤,卷发,优雅的发髻。她穿着一件饰有亮片的黑色露肩礼服,戴着一条闪闪发光的钻石项链。她的妆容是迷人的大胆眼线和裸色口红。背景是深蓝色和白色的几何图案。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_00.mp4'
    },
    {
      id: 1,
      genid: MODEL_List[1],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/tianshipro/175015395206471824.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/tianshipro/175015412268117761.png',
      localstoragename: 'tianshipro',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Woman/【欧美女星】甜美天使_真实感人像_v2.0.safetensors',
      default: '',
      english: 'Photograph of a young woman with fair skin, light brown hair, and striking blue eyes. She wears a light blue denim shirt and blue jeans, sitting on a green cushioned surface. Her expression is neutral, with a hand gently touching her face. The background features a blurred, warm-toned curtain.',
      chinese: '照片中的年轻女子皮肤白皙,浅棕色头发,蓝眼睛引人注目。她穿着浅蓝色牛仔衬衫和蓝色牛仔裤,坐在绿色的软垫地板上。她的表情是中性的,一只手轻轻地摸着她的脸。背景是一个模糊的暖色调窗帘。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_01.mp4'
    },
    // 美甲手图 =================================================================================================================================
    {
      id: 2,
      genid: HAND_List[0],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/duobaamgd/MJ2506%E5%A4%9A%E5%B7%B4%E8%83%BA%E7%BE%8E%E7%94%B2-%E6%9E%9C%E5%86%BB03-2.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/duobaamgd/MJ2506%E5%A4%9A%E5%B7%B4%E8%83%BA%E7%BE%8E%E7%94%B2-%E6%9E%9C%E5%86%BB03-3.png',
      localstoragename: 'duobaan',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Lora/美甲 多巴胺 网图_LoRA-F1..safetensors',
      default: '',
      english: 'A high-definition picture, slender and fair hands, nail art display, dopamine color matching, realistic texture,only one screen',
      chinese: '高清画面,修长白皙的双手,美甲艺术展示,多巴胺配色,质感逼真,只有一个画面',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_02.mp4'
    },
    {
      id: 3,
      genid: HAND_List[1],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/chinameijia/175015584797875591.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/chinameijia/175015589722713369.png',
      localstoragename: 'ChinaMeijia',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_MJ/绝美水墨风美甲--高级感拉满_1.0.safetensors',
      default: 'guofengmeijia',
      english: 'close-up photos with light skin tones and neatly trimmed, square nails, nail characteristics and subtle white bases, soft blue gradient techniques, black, liquid, abstract line art painted on each nail, like ink wash art',
      chinese: '特写照片用浅色的肤色和整齐的修剪,方形的指甲,指甲特征和微妙的白色底色,柔和的蓝色渐变技术,黑色,液体,抽象的线条艺术画在每个指甲上,像水墨艺术',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_03.mp4'
    },
    {
      id: 4,
      genid: HAND_List[2],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/davimeijia/175021101518449194.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/davimeijia/175021617511896595.png',
      localstoragename: 'DaviMeiJia',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_MJ/DaviMeijia.safetensors',
      default: 'meijia',
      english: 'A close-up of a womans hand adorned with a stunning nail art design. Each nail is uniquely painted with intricate patterns, some featuring delicate florals, while others have geometric shapes with metallic accents. The nails are polished in shades of deep purple, gold, and silver, with a touch of glitter that catches the light. The hand is gently resting on a soft, luxurious fabric, adding to the elegance of the scene. The lighting highlights the fine details of the nail art and the smoothness of the skin.',
      chinese: '一个女人手上装饰着令人惊叹的指甲艺术设计的特写。每个指甲都独特地涂上了复杂的图案,有些以精致的花朵为特色,而另一些则以金属色调的几何形状为特色。指甲被抛光成深紫色、金色和银色,并带有一丝闪闪发光的光泽。手轻轻地放在柔软奢华的织物上,增添了场景的优雅。灯光突出了指甲艺术的细节和皮肤的光滑度。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_04.mp4'
    },
    {
      id: 5,
      genid: HAND_List[3],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/duobaan/175023760712537814.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/duobaan/175023764082720455.png',
      localstoragename: 'duobaan',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Lora/美甲 多巴胺 网图_LoRA-F1..safetensors',
      default: '',
      english: 'A high-definition picture of slender and fair hands, showcasing nail art with solid colored nails. The thumb nail is light red, the index finger nail is bare with a little glitter on top, the middle finger nail is light red, the ring finger nail is gold and silver, and the little finger nail is light gray blue, with a realistic texture,',
      chinese: '一张修长而白皙的手的高清图片,展示了纯色指甲艺术。拇指指甲是淡红色的,食指指甲是裸露的,上面有一点闪光,中指指甲是淡红色的,无名指指甲是金色和银色的,小指指甲是浅灰蓝色的,具有逼真的质感。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_05.mp4'
    },
    {
      id: 6,
      class: 'Flux',
      img1: '',
      img2: '',
      localstoragename: '',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: '',
      default: '',
      english: '',
      chinese: '',
      width: 512,
      height: 768,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: null
    },
    {
      id: 7,
      genid: HAND_List[4],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/Insmeijia/001%20(1).png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/Insmeijia/001%20(2).png',
      localstoragename: 'Insmeijia',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Lora/美甲 手部 甲片图案_LoRA-F1..safetensors',
      default: 'nail,nail,',
      english: '',
      chinese: '',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_07.mp4'
    },
    // 电商海报 =================================================================================================================================
    {
      id: 8,
      genid: POSTER_List[0],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/%E6%89%8B%E6%8C%81%E4%BA%A7%E5%93%8101/ComfyUI_temp_jpvpv_00001_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/%E6%89%8B%E6%8C%81%E4%BA%A7%E5%93%8101/ComfyUI_temp_zsiqf_00001_.png',
      localstoragename: 'hands_product1',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Lora/手模 产品1_LoRA-F1.safetensors',
      default: '',
      english: 'hands and products,one hand,smear,realistic,fingernails,simple background,out of frame,english text,shiny,copy“morejoy”,',
      chinese: '手与产品, 一只手, 涂抹, 逼真, 指甲, 简单背景, 超出画面, 英文文本, 闪亮, 复制“morejoy”',
      width: 1600,
      height: 1600,
      steps: 15,
      guidance: 6,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_08.mp4'
    },
    {
      id: 9,
      genid: POSTER_List[1],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/%E6%89%8B%E6%8C%81%E4%BA%A7%E5%93%812/ComfyUI_temp_genmd_00002_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/%E6%89%8B%E6%8C%81%E4%BA%A7%E5%93%812/ComfyUI_temp_phkoa_00001_.png',
      localstoragename: 'hands_product2',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Lora/手模 产品2_LoRA-F1..safetensors',
      default: '',
      english: 'In the picture, a hand is holding a nail polish product. The fingernails of the hand are painted with light-yellow nail polish, exuding a delicate and elegant charm. The nail polish bottle in the hand features a gradient design, transitioning gradually from light yellow at the bottom to light pink at the top, creating an overall soft and stylish aesthetic. The bottle is printed with the product name and capacity information, indicating that it contains 15 milliliters (0.5 fluid ounces). The background showcases a gradient sky tone, shifting from light pink at the bottom to light blue at the top, which fosters a tranquil and comfortable atmosphere. The text "morejoy" is replicated on the image.',
      chinese: '图片中一只手拿着一款指甲油产品。这只手的指甲涂着浅黄色的指甲油,散发着精致优雅的气息。手中的指甲油瓶采用渐变设计,从底部的浅黄色逐渐过渡到顶部的浅粉色,整体呈现出柔和时尚的美感。瓶子上印有产品名称和容量信息,表明其容量为 15 毫升(0.5 液量盎司）。背景呈现出渐变的天空色调,从底部的浅粉色过渡到顶部的浅蓝色,营造出宁静舒适的氛围。瓶身上出现“morejoy”字样。',
      width: 1600,
      height: 1600,
      steps: 15,
      guidance: 6,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_09.mp4'
    },
    {
      id: 10,
      genid: POSTER_List[2],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/%E5%8C%97%E6%AC%A7%E7%AE%80%E7%BA%A6%E9%A3%8E/ComfyUI_temp_qpxpt_00003_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/%E5%8C%97%E6%AC%A7%E7%AE%80%E7%BA%A6%E9%A3%8E/ComfyUI_temp_qpxpt_00006_.png',
      localstoragename: 'beiou_simple',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Dianshang/电商产品场景摄影视觉_2.0.safetensors',
      default: '',
      english: 'This is a photograph of a modern living room, showcasing a sleek orange-and-white nail dryer accompanied by multiple bottles of nail polish and some manicure tools, and the logo text "MOREJOY" on the bottle, all placed on a round, textured white table. In the background, there is a greenish-orange sofa paired with matching orange cushions. The entire scene is bright and airy, with soft natural light streaming in through the windows,',
      chinese: '这是一张现代客厅的照片,画面中展示了一台造型时尚的橙白相间的美甲干燥器,旁边摆放着多瓶指甲油和一些美甲工具,瓶身上的标识文字为“MOREJOY”,所有物品都放置在一个圆形、有纹理的白色桌子上。背景中有一张略带橙色调的沙发,搭配着同样颜色的橙色靠垫。整个场景明亮而宽敞,柔和的自然光线透过窗户洒了进来。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_10.mp4'
    },
    {
      id: 11,
      genid: POSTER_List[3],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/011%E6%B6%B2%E6%80%81%E7%8E%BB%E7%92%83/ComfyUI_temp_rcfdc_00002_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/011%E6%B6%B2%E6%80%81%E7%8E%BB%E7%92%83/ComfyUI_temp_xyofi_00001_.png',
      localstoragename: 'glass_bottle',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Lora/海报 玻璃_LoRA-F1..safetensors',
      default: 'zfszy09,',
      english: 'Ultra clear,fine details,8k,1 bottle of nail polish product with a slender cylindrical transparent glass bottle body white lid,bottle body logo text "MOREJOY",vertically suspended,{background orange curved liquid glass half surrounding the product), liquid bubbles inside the background glass, silver white background, clean background, bright tone, minimalist,',
      chinese: '超清晰,细节精美,8K,1瓶指甲油产品,细长圆柱形透明玻璃瓶身,白色瓶盖,瓶身有“MOREJOY”字样,垂直悬挂,（背景橙色弯曲的液态玻璃半环绕产品）,背景玻璃内有气泡,银白色背景,干净背景,明亮色调,极简风格。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_11.mp4'
    },
    {
      id: 12,
      genid: POSTER_List[4],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/012%E8%8A%B1%E6%9C%B5%E8%93%9D%E5%A4%A9/ComfyUI_temp_astgn_00001_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/012%E8%8A%B1%E6%9C%B5%E8%93%9D%E5%A4%A9/ComfyUI_temp_astgn_00003_.png',
      localstoragename: 'flower_blueday',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Dianshang/F.1-电商草地蓝天场景_V1.safetensors',
      default: 'ds,',
      english: 'ultra high definition details,This is a high-resolution photograph featuring a clear glass bottle of perfume, prominently placed in the center of the image. The bottle is positioned on a smooth, white surface, which adds a clean and minimalist aesthetic to the composition, and the logo text "MOREJOY" on the bottle.\nSurrounding the bottle are various flowers in full bloom, enhancing the scenes natural beauty.To the left, there is a large, fully opened peach- colored rose with delicate green leaves, adding softness and elegance.To its right, there are clusters of tiny, delicate white flowers with green stems, creating an airy and delicate texture.In the foreground, theres a vibrant orange lily with a yellow center, adding warmth and brightness to the composition.The petals of the flowers are soft and delicate, with a realistic texture that contrasts beautifully with the smooth, reflective surface of the pedestal,with a light blue sky as the background.\n\nThe overall mood of the photograph is serene and luxurious, with an emphasis on natural beauty and elegance, making it a visually appealing and inviting image.',
      chinese: '超高清细节,这是一张高分辨率的照片,画面中有一个清晰的香水玻璃瓶,醒目地置于画面中央。瓶子放置在一个光滑的白色表面上,为构图增添了干净简约的美感,瓶上的标识文字为“MOREJOY”。瓶子周围是各种盛开的鲜花,进一步增添了场景的自然之美。左边有一朵大而完全绽放的桃色玫瑰,带有精致的绿叶,增添了柔和与优雅的氛围。右边有几簇小巧而精致的白色花朵,带有绿色茎干,营造出轻盈而精致的质感。在前景中,有一朵鲜艳的橙色百合,中心是黄色的花蕊,为构图增添了温暖和明亮的色彩。花朵的花瓣柔软而细腻,与底座光滑的反光表面形成鲜明对比,背景是浅蓝色的天空。这张照片的整体氛围宁静而奢华,强调了自然之美和优雅,使其成为一幅视觉上吸引人且令人愉悦的图像。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_12.mp4'
    },
    {
      id: 13,
      genid: POSTER_List[5],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/013%E5%AE%9E%E9%AA%8C%E5%AE%A4%E7%83%A7%E6%9D%AF/ComfyUI_temp_pmxjj_00003_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/013%E5%AE%9E%E9%AA%8C%E5%AE%A4%E7%83%A7%E6%9D%AF/ComfyUI_temp_pmxjj_00009_.png',
      localstoragename: 'lab',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Dianshang/电商实验产品摄影_电商实验室产品摄影.safetensors',
      default: 'ds,',
      english: 'Ultra clear, 8k, laboratory product photography, yellow white gradient glass bottle makeup remover oil, transparent glass material makeup remover oil, bottle sticker text MOREJOY, placed on a gradient background, with different shaped beakers placed on the left and right sides, staggered in height, large and small, front and back, blurred foreground and background burning motion, highlighting the main product, ((light spot)), a small amount of liquid on the ground, silver white background, spatial sense, hierarchy, edge transparent ambient light, edge transparent, strong contrast between glass brightness and darkness, clear edge, clear structure, high-end sense, backlight, brightness adjustment, product transparency, light transmission, brightness adjustment, upward view, large perspective, impact, low angle shooting, dynamic blur, exquisite details of laboratory equipment. Soft lighting and depth of field control enhance the sense of hierarchy, multiple depths of field',
      chinese: '超清晰、8K、实验室产品摄影、黄白色渐变玻璃瓶卸妆油、透明玻璃材质卸妆油、瓶贴文字“MOREJOY”,置于渐变背景之上,左侧和右侧放置不同形状的烧杯,高低错落、大小各异、前后排列,模糊的前景和背景呈现出燃烧般的动态效果,突出主产品（（光斑））,（少量液体）落在银白色背景上,具有空间感、层次感、边缘透明的环境光、边缘透明,玻璃亮度与黑暗之间的强烈对比,清晰的边缘、清晰的结构、高端感、背光、亮度调节、产品透明度、光线传输、亮度调节、向上视角、大视角、冲击力、低角度拍摄、动态模糊、实验室设备的精致细节。柔和的照明和景深控制增强了层次感,多个景深。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_13.mp4'
    },
    {
      id: 14,
      genid: MODEL_List[2],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/014%E6%AC%A7%E7%BE%8E%E5%A5%B3%E7%94%9F/ComfyUI_00086_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/014%E6%AC%A7%E7%BE%8E%E5%A5%B3%E7%94%9F/ComfyUI_00087_.png',
      localstoragename: 'oumei_woman',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Dianshang/电商实验产品摄影_电商实验室产品摄影.safetensors',
      default: '',
      english: 'photo of young woman,highlight hair,wearing dress,rim lighting,studio lighting,looking at the camera,dslr,ultra quality,sharp focus,tack sharp,dof,film grain,Fujifilm XT3,crystal clear,8K UHD,highly detailed glossy eyes,high detailed skin,skin pores,[Amber Heard: Emma Watson :0.5],',
      chinese: '年轻女子的照片,高光头发,身着连衣裙,边缘照明,影棚灯光,直视镜头,数码单反相机,超高清画质,清晰对焦,锐利无比,景深,胶片颗粒,富士 XT3,晶莹剔透,8K 超高清,眼部细节丰富,皮肤纹理清晰,毛孔可见,[艾梅柏·希尔德：艾玛·沃特森：0.5]',
      width: 1600,
      height: 1600,
      steps: 15,
      guidance: 3.5,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_14.mp4'
    },
    {
      id: 15,
      genid: MODEL_List[3],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/015%E6%AC%A7%E7%BE%8E%E4%BF%8F%E7%9A%AE/ComfyUI_00091_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/015%E6%AC%A7%E7%BE%8E%E4%BF%8F%E7%9A%AE/ComfyUI_00095_.png',
      localstoragename: 'oumei_qiaopi',
      ckptname: 'Anything v6.8万物通用F.1大模型_v1.0.safetensors',
      loraname: 'Flux_Woman/【商业摄影】欧美_珠宝饰品展示_1.0.safetensors',
      default: '',
      english: 'Fashion photography, Bazaar style fashion photography, portrait photography, showcasing a girl, European and American model, a young woman with long, straight black hair and brown skin from above the knees. Her hair has bangs just above her eyebrows. She was wearing a light grey green strapless denim top with a few buttons on the front. The top was cut short, revealing a part of her abdomen. She was also wearing a pleated mini skirt, similar in color to grey green jeans. This dress is very short, just above her knees. She posed, tilting her body slightly to the side and bending her arms slightly at the elbows. Her expression was serious, with a slight downward gaze. She seemed to be wearing black boots, with only the top of the boots visible. The background is pure white.,{Best Quality}, {Masterpiece}, {High Resolution}, Original, Extremely Fine 8K Wallpaper, {Extremely Exquisite and Beautiful},',
      chinese: '时尚摄影,芭莎风格的时尚摄影,人像摄影,展示一位女孩,欧美模特,一位有着从膝盖以上露出的棕色皮肤和黑色直发的年轻女子。她的头发在眉毛上方有刘海。她穿着一件前面有几颗纽扣的浅灰绿色无肩带牛仔上衣,上衣裁剪得很短,露出了腹部的一部分。她还穿着一条褶皱迷你裙,颜色与灰绿色牛仔裤相似。这条裙子非常短,只到膝盖上方。她摆着姿势,身体微微侧倾,双臂在肘部微微弯曲。她的表情严肃,目光微微向下。她似乎穿着黑色靴子,只有靴子的顶部可见。背景是纯白色。{最佳品质},{杰作},{高分辨率},原作,极其精美的 8K 壁纸,{极其精致美丽}',
      width: 1600,
      height: 1600,
      steps: 20,
      guidance: 3.5,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_15.mp4'
    },
    {
      id: 16,
      genid: HAND_List[5],
      class: 'SD1.5',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/16%E9%80%9A%E7%94%A8%E7%94%B2%E7%89%87/ComfyUI_temp_mhoue_00009_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/16%E9%80%9A%E7%94%A8%E7%94%B2%E7%89%87/ComfyUI_temp_pvndr_00001_.png',
      localstoragename: 'meijiav1.5',
      ckptname: 'majicMIX realistic 麦橘写实_v7.safetensors',
      loraname: 'SD1.5/视觉应用集 - 真人美甲_v2.1.safetensors',
      default: '',
      english: 'Marble lines, Saba,colorful, blending,best quality, official art, 8k wallpaper, highly detailed, illustration, detailed',
      chinese: '大理石纹理,萨巴,色彩斑斓,融合,最佳品质,官方艺术,8K 壁纸,细节丰富,插画,细致的',
      width: 512,
      height: 512,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_16.mp4'
    },
    {
      id: 17,
      genid: POSTER_List[6],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/17%20%E7%8E%BB%E7%92%83%E7%AB%8B%E6%96%B9%E4%BD%93/ComfyUI_temp_lslvd_00003_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/17%20%E7%8E%BB%E7%92%83%E7%AB%8B%E6%96%B9%E4%BD%93/ComfyUI_temp_lslvd_00007_.png',
      localstoragename: 'grassgeometry',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Lora/海报 玻璃_LoRA-F1..safetensors',
      default: '',
      english: 'Ultra-clear, exquisite details, 8K resolution. A skincare product with the bottle text "MOREJOY" stands casually on an orange cubic glass, and the cube glass background at random behind, orange white gradient background, sense of volume, sense of space, stacking, constructivism, sense of rhythm, sense of rhythm, high-level composition, highlight the product, clean background, no other things in the background, bright tone,d',
      chinese: '一个透明玻璃材质的 “morejoy”“参养霜瓶子,瓶身呈圆润的水滴状,内装橙黄色膏体,瓶盖为白色哑光质地,顶部有弧形凹槽设计；瓶身正面印有白色品牌名称 “morejoy” 及产品英文说明 “CONCENTRATED GINSENG RENEWING CREAM EX”。场景{场景描述)：白色渐变背景,底部为橙色渐变反光台面,瓶子放置于台面上,台面反射出瓶子完整的倒影。风格（定义风格）：高端简约的美妆产品广告风格,写实精致,突出产品的质感与奢华感。镜头语言：中景俯拍角度,聚焦瓶子主体及倒影,画面构图对称平衡。氛围词：纯净高级、温润奢华、自然通透,展现护肤品的高端定位与成分纯净感。细节修饰：玻璃瓶身通透,橙黄色膏体色泽均匀,带有细腻光泽；白色瓶盖边缘光滑,与瓶身过渡自然；倒影清晰且略带模糊虚化,增强空间感；光线从顶部柔和打亮,强化瓶身的透明质感、膏体的温润光泽及台面的渐变反光,背景白色与产品橙色形成鲜明对比,突出主体。',
      width: 1600,
      height: 1600,
      steps: 20,
      guidance: 3.5,
      weight: 0.85,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_17.mp4'
    },
    {
      id: 18,
      genid: POSTER_List[7],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/18%20%E6%B0%B4%E4%B8%AD%E5%9C%BA%E6%99%AF/ComfyUI_temp_jpqax_00003_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/18%20%E6%B0%B4%E4%B8%AD%E5%9C%BA%E6%99%AF/ComfyUI_temp_jpqax_00007_.png',
      localstoragename: 'grassgeometry_18',
      ckptname: '一站式电商大模型-场景-产品-主图_FLUX版.safetensors',
      loraname: 'Flux_Dianshang/电商产品水中摄影场景_FLUX-V1.safetensors',
      default: '',
      english: 'A flask of MOREJOY hydration spray sits perched on undulating waters,its transparent form capturing light in every curve. The minimalist design,with a orange cap and white lettering,highlights the products purity.The bilingual label(English and Italian) extols its ability to rejuvenate skin instantly.The water beneath mirrors the flasks elegance.',
      chinese: '一瓶 MOREJOY 水润喷雾置于波光粼粼的水面上,其透明的瓶身在每一处曲线都折射着光芒。极简的设计搭配橙色瓶盖和白色字样,凸显出产品的纯净。双语标签（英语和意大利语）赞颂其能瞬间为肌肤补水的功效。下方的水面映照着喷雾瓶的优雅。',
      width: 1600,
      height: 1600,
      steps: 20,
      guidance: 5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_18.mp4'
    },
    {
      id: 19,
      genid: POSTER_List[8],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/19%20%E6%B0%B4%E6%B3%A2%E6%91%84%E5%BD%B1/ComfyUI_temp_jpqax_00019_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/19%20%E6%B0%B4%E6%B3%A2%E6%91%84%E5%BD%B1/ComfyUI_temp_jpqax_00020_.png',
      localstoragename: 'grassgeometry_19',
      ckptname: '产品写实｜F.1简朴归真V2电商全能商业视觉KV海报产品设计_V2.safetensors',
      loraname: 'Flux_Dianshang/电商产品水中摄影场景_FLUX-V1.safetensors',
      default: '',
      english: 'A jar of MOREJOY skin rejuvenating cream rests atop a serene water surface,its glass body shimmering against the liquids gentle ripples. The jar sports a sleek silver lid and a transparent base revealing the creamy texture within. The label,in both French and Spanish,boasts of the products anti-aging properties,standing out against the reflective water.,',
      chinese: '一瓶 MOREJOY 美肤焕颜霜静置在平静的水面上,玻璃瓶身在水面的轻柔波纹中泛着微光。瓶身配有银色的光滑盖子,透明的底部展示着瓶内乳霜状的质地。标签上用法语和西班牙语写着该产品的抗衰老功效,在反光的水面上格外醒目。',
      width: 1600,
      height: 1600,
      steps: 20,
      guidance: 5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_19.mp4'
    },
    {
      id: 20,
      genid: POSTER_List[9],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/20%20%E7%A7%91%E7%A0%94%E6%97%B6%E9%92%9F/ComfyUI_temp_djpxm_00003_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/20%20%E7%A7%91%E7%A0%94%E6%97%B6%E9%92%9F/ComfyUI_temp_djpxm_00006_.png',
      localstoragename: 'grassgeometry_20',
      ckptname: '绘梦电商视觉创意魔方 F.1 _ 海报场景运营 产品摄影设计_创意魔方V6.safetensors',
      loraname: 'Flux_Dianshang/电商渲染级医美科研风格_v1.0.safetensors',
      default: 'Yimei, Yimei. ',
      english: 'This is a photograph of "MOREJOY" skincare products, featuring two sleek tubes with metallic silver and an orange-to-white gradient. They are placed on a transparent, minimalist clock face with silver hands. The background is a soft light orange gradient, creating a luxurious and futuristic aesthetic. The products are positioned centrally, emphasizing their high-end and modern design.',
      chinese: '这是一张“MOREJOY”护肤产品的照片,照片中展示的是两个造型流畅的金属银色管状产品,以及一个从橙色到白色的渐变色部分。它们放置在一个透明的简约时钟面上,钟面上有银色指针。背景是柔和的浅橙色渐变色,营造出一种奢华且未来主义的美感。这些产品被置于画面中央,突显了其高端和现代的设计风格。',
      width: 1600,
      height: 1600,
      steps: 20,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_20.mp4'
    },
    {
      id: 21,
      genid: POSTER_List[10],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/21%20%E5%AE%A4%E5%A4%96%E6%B3%B3%E6%B1%A0/ComfyUI_temp_eykhc_00001_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/21%20%E5%AE%A4%E5%A4%96%E6%B3%B3%E6%B1%A0/ComfyUI_temp_fdttz_00001_.png',
      localstoragename: 'grassgeometry_21',
      ckptname: '产品写实｜F.1简朴归真V2电商全能商业视觉KV海报产品设计_V2.safetensors',
      loraname: 'Flux_Skin/F.1_护肤品防晒户外场景渲染_V1.safetensors',
      default: '',
      english: '8K,ultra-clear,high resolution,high texture,fine details,Sunscreen photography,1 white sunscreen lying on the swimming circle in the water,brand logo MOREJOY and SPF45+on the bottle body,swimming pool background,splashing water,swimming circle,ocean ball,palm leaves,refreshing colors,summer,real photography,',
      chinese: '8K、超清晰、高分辨率、高纹理、精细细节、防晒摄影、一瓶白色防晒霜漂浮在水中的游泳圈上,瓶身上有品牌标识“MOREJOY”和防晒指数 45+,游泳池背景、溅起的水花、游泳圈、海洋球、棕榈叶、清新色彩、夏日、真实摄影。',
      width: 1600,
      height: 1600,
      steps: 20,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_21.mp4'
    },
    {
      id: 22,
      genid: POSTER_List[11],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/22%20%E5%AE%9E%E9%AA%8C%E5%AE%A4/ComfyUI_temp_ssxuo_00006_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/22%20%E5%AE%9E%E9%AA%8C%E5%AE%A4/ComfyUI_temp_ssxuo_00012_.png',
      localstoragename: 'grassgeometry_22',
      ckptname: '产品写实｜F.1简朴归真V2电商全能商业视觉KV海报产品设计_V2.safetensors',
      loraname: 'Flux_Dianshang/电商实验产品摄影_电商实验室产品摄影.safetensors',
      default: 'keyan,',
      english: 'In commercial photography,a white medicine bottle is placed on a transparent laboratory shelf, bottle sticker text MOREJOY. On the left is a distillation flask containing a golden liquid,and on the right is an iron stand that stably supports a separating funnel. The liquid in the funnel is clearly layered,and the tip is tightly attached to the beaker below. The extraction and separation are about to begin,surrounded by supporting iron stands,separating funnels,beakers,and other instruments to create a typical chemical experimental atmosphere. The overall background is light colored,creating a professional and scientific atmosphere for showcasing beauty and skincare products.,',
      chinese: '在商业摄影中,一个白色的药瓶被放置在透明的实验室架子上,瓶身贴有“MOREJOY”的标签。左边是一个装有金色液体的蒸馏瓶,右边是一个铁制支架,它稳定地支撑着一个分离漏斗。漏斗中的液体清晰地分层,漏斗的顶端紧密地贴合在下面的烧杯上。萃取和分离即将开始,周围环绕着支撑的铁架、分离漏斗、烧杯以及其他仪器,营造出典型的化学实验氛围。整体背景为浅色,为展示美容和护肤产品营造出专业且科学的氛围。',
      width: 1600,
      height: 1600,
      steps: 20,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_22.mp4'
    },
    {
      id: 23,
      genid: POSTER_List[12],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/23%E8%BF%90%E5%8A%A8%E5%9C%BA%E6%99%AF/ComfyUI_temp_ssxuo_00019_.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/23%E8%BF%90%E5%8A%A8%E5%9C%BA%E6%99%AF/ComfyUI_temp_ssxuo_00020_.png',
      localstoragename: 'grassgeometry_23',
      ckptname: '产品写实｜F.1简朴归真V2电商全能商业视觉KV海报产品设计_V2.safetensors',
      loraname: 'Flux_Skin/F.1_护肤品防晒户外场景渲染_V1.safetensors',
      default: 'zfszy,',
      english: '8K,ultra-clear,high resolution,high texture,fine details,Sunscreen photography,two white sunscreens in diagonal composition,bottle brand logo MOREJOY and SPF45+,tennis court background,blue ground,orange tennis balls,overhead angle,refreshing color tone,summer,C4d rendering,',
      chinese: '8K、超清晰、高分辨率、高纹理、精细细节、防晒摄影、呈对角线排列的两块白色防晒霜、品牌标识 MOREJOY 和 SPF45+、网球场背景、蓝色地面、橙色网球、俯视角度、清新色彩基调、夏季、C4D 渲染图',
      width: 1600,
      height: 1600,
      steps: 20,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_23.mp4'
    },
    {
      id: 24,
      genid: HAND_List[6],
      class: 'SDXL',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/24%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94%5D/768x1024_01.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/24%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94%5D/768x1024_02.png',
      localstoragename: 'sdxl_fingernail_v1.5',
      ckptname: 'SDXL/XL极致写实 _ 万物摄影 _ FLUX模拟器_V1.safetensors',
      loraname: 'SDXL/MoreJoy_Finger_XL_V1.5.safetensors',
      default: 'meijia,',
      english: 'simple background, photorealistic, fingernails, realistic, orange background, nail polish, solo, gradient background',
      chinese: '简约背景,逼真效果,指甲,写实风格,橙色背景,指甲油,单个,渐变背景',
      width: 1024,
      height: 1024,
      steps: 12,
      guidance: 3.5,
      weight: 1,
      cfg: 3.5,
      galleryname: 'dazahuisdxl',
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_24.mp4'
    },
    {
      id: 25,
      genid: HAND_List[7],
      class: 'SDXL',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/25%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94V1.0%5D/shoutu01-2.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/25%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94V1.0%5D/shoutu01-3.png',
      localstoragename: 'sdxl_fingernail_v1.0',
      ckptname: 'SDXL/XL极致写实 _ 万物摄影 _ FLUX模拟器_V1.safetensors',
      loraname: 'SDXL/Fingernail_V1.0.safetensors',
      default: 'meijia,',
      english: 'hand focus, photorealistic, realistic, solo, simple background, fingernails, grey background, nail polish, close-up',
      chinese: '手部特写,逼真写实,单手,背景简洁,指甲,指甲油,特写镜头',
      width: 1024,
      height: 1024,
      steps: 20,
      guidance: 3.5,
      weight: 1,
      cfg: 3.5,
      galleryname: 'cateyesxl',
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_25.mp4'
    },
    {
      id: null,
      genid: HAND_List[8],
      class: 'SDXL',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/26%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94V0.7%5D/shoutu02-2.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/26%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94V0.7%5D/shoutu02-3.png',
      localstoragename: 'sdxl_fingernail_v0.7',
      ckptname: 'SDXL/XL极致写实 _ 万物摄影 _ FLUX模拟器_V1.safetensors',
      loraname: 'SDXL/Fingernail_V0.7.safetensors',
      default: 'meijia,',
      english: 'hand focus, realistic, fingernails, ring, photorealistic, simple background, glitter, grey background, jewelry, close-up, blurry',
      chinese: '手部特写,逼真,指甲,戒指,超写实,简单背景,闪光,灰色背景,珠宝,特写, 高清',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      cfg: 3.5,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_26.mp4'
    },
    {
      id: 27,
      genid: HAND_List[9],
      class: 'FluxI2I',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/27%E7%8C%AB%E7%9C%BC%E7%94%B2%E7%89%87/maoyan02.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/27%E7%8C%AB%E7%9C%BC%E7%94%B2%E7%89%87/maoyan03.png',
      localstoragename: 'cat_eyes_v1.0',
      ckptname: '产品写实｜F.1简朴归真V2电商全能商业视觉KV海报产品设计_V2.safetensors',
      loraname: 'Flux_MJ/Flux_CatEyesV1.0_rank16_bf16.safetensors',
      default: 'meijia,',
      english: 'This is a close-up photograph of a womans hand showcasing well-manicured nails. Her nails are long and rectangular, with a glossy, light pink polish that reflects light. The skin around the nails is smooth and pale. The hand is gently resting on a white, textured fabric, possibly a piece of clothing or a towel. The background is blurred and neutral, emphasizing the hand and nails. The overall style is clean and elegant, focusing on the beauty and detail of the manicure.',
      chinese: '这是一张特写照片,展示了一位女士的手部,她的指甲修剪得十分整齐。她的指甲很长且呈矩形,涂着一层有光泽的淡粉色指甲油,能反射光线。背景模糊且色调中性,突出了这只手和指甲。整体风格简洁优雅,重点在于美甲的美观和细节。',
      width: 1024,
      height: 1024,
      steps: 20,
      guidance: 3.5,
      weight: 0.85,
      galleryname: 'cateyes',
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/%E7%8C%AB%E7%9C%BC%E7%94%B2%E7%89%87%E8%87%AA%E7%A0%94v1%20027.mp4'
    },
    {
      id: 28,
      genid: HAND_List[10],
      class: 'FluxI2I',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/28%E9%BB%91%E6%89%8B%E5%9B%BE/002.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/28%E9%BB%91%E6%89%8B%E5%9B%BE/003.png',
      localstoragename: 'black_hands_v1.0',
      ckptname: '产品写实｜F.1简朴归真V2电商全能商业视觉KV海报产品设计_V2.safetensors',
      loraname: 'Flux_Free/Flux_blackhandsV1.0_rank32_bf16.safetensors',
      default: 'meijia,',
      english: '',
      chinese: '一张特写照片,画面中是一只肤色较深的手,指甲涂着鲜艳的指甲油,指甲很长。这只手放在一块柔软的奶油色织物上,增添了温馨的质感。整体构图突出了醒目的指甲颜色,展现出一种现代时尚的风格。',
      width: 1024,
      height: 1024,
      steps: 20,
      guidance: 3.5,
      weight: 0.85,
      galleryname: 'black_hands',
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/%E9%80%9A%E7%94%A8%E7%94%B2%E7%89%87%E8%87%AA%E7%A0%94%E9%BB%91%E6%89%8B028.mp4'
    },
    {
      id: 29,
      genid: HAND_List[11],
      class: 'FluxI2I',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/29%E9%80%9A%E7%94%A8%E5%9B%BE%E5%BA%93/common-02.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/29%E9%80%9A%E7%94%A8%E5%9B%BE%E5%BA%93/common-03.png',
      localstoragename: 'black_hands_v2.0',
      ckptname: '产品写实｜F.1简朴归真V2电商全能商业视觉KV海报产品设计_V2.safetensors',
      loraname: 'Flux_MJ/Flux_CatEyesV1.0_rank16_bf16.safetensors',
      default: 'meijia,',
      english: '',
      chinese: '一张特写照片,指甲涂着指甲油,指甲很长。整体构图突出了醒目的指甲颜色,展现出一种现代时尚的风格。',
      width: 1024,
      height: 1024,
      steps: 20,
      guidance: 3.5,
      weight: 0.85,
      galleryname: 'common_hands',
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/%E9%80%9A%E7%94%A8%E7%94%B2%E7%89%87%E8%87%AA%E7%A0%94V2.0Flux029.mp4'
    },
    {
      id: 30,
      genid: HAND_List[12],
      class: 'Flux',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/30%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2V0.7/030-1.png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/30%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2V0.7/030-2.png',
      localstoragename: 'Insmeijia',
      ckptname: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
      loraname: 'Flux_Free/FLUX.素雅显白时尚美甲_V1 手部素雅.safetensors',
      default: 'F1CNMeijia,',
      english: ' The image shows a close-up of a hand with neatly manicured nails. The nails are painted in a gradient of light to dark, with a subtle shimmer effect. Each nail is decorated with small, shiny embellishments, including rhinestones and a butterfly design. The hand is resting on a soft, white, fluffy surface, possibly a fur or faux fur garment. In the background, there is a mirror reflecting part of the hand and a ring on the ring finger. The hand also has a tattoo of a cross on the pinky finger. The overall setting appears to be indoors, with a focus on the detailed and elegant nail design.',
      chinese: '这张图片展示了一只手的特写，指甲修剪得整整齐齐。指甲涂着由浅至深的渐变色，还带有细微的闪光效果。每根指甲上都装饰着小巧闪亮的装饰物，包括水钻和蝴蝶图案。这只手放在柔软、洁白、蓬松的表面上，可能是毛皮或人造毛皮制成的衣物。整体场景似乎是在室内，重点突出精致优雅的指甲设计。',
      width: 1024,
      height: 1024,
      steps: 15,
      guidance: 3.5,
      weight: 1,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_00.mp4'
    },
    {
      id: 31,
      genid: HAND_List[13],
      class: 'SD1.5',
      img1: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/31%E5%9C%A3%E8%AF%9E%E7%BE%8E%E7%94%B2/sdj%20(4).png',
      img2: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/31%E5%9C%A3%E8%AF%9E%E7%BE%8E%E7%94%B2/sdj%20(4)~1.png',
      localstoragename: 'christmas',
      ckptname: 'majicMIX realistic 麦橘写实_v7.safetensors',
      loraname: 'SD1.5/Christmas_v2.5.safetensors',
      default: 'sdj',
      english: 'sdj',
      chinese: '',
      width: 512,
      height: 512,
      video_demo: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_list_video/commonDemo_00.mp4'
    }
  ],
  sourceTemplateList: []

}

const mutations = {
  sourceTemplateList(state, data) {
    data.forEach(element => {
      const obj = {
        id: element[0],
        genid: element[1],
        class: element[2],
        img1: element[3],
        img2: element[4],
        localstoragename: element[5],
        ckptname: element[6],
        loraname: element[7],
        default: element[8],
        english: element[9],
        chinese: element[10],
        width: element[11],
        height: element[12],
        steps: element[13],
        guidance: element[14],
        weight: element[15],
        cfg: element[16],
        galleryname: element[17],
        video_demo: element[18]
      }
      const exists = state.sourceTemplateList.some(item => item.id === obj.id)
      if (!exists) {
        state.sourceTemplateList.push(obj)
      }
    })
  }
}

const actions = {
  async getTemplateList(context) {
    const res = await homePageTemplate()
    context.commit('sourceTemplateList', res.tables)
  }
}

const getters = {
  getterTemplateList: (state) => {
    return state.sourceTemplateList
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
